import { ReactNode } from "react";

import { cn } from "@/lib/utils";

export default function MaxWidthWrapper({
  className,
  children,
  large = false,
}: {
  className?: string;
  large?: boolean;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "mx-auto w-full max-w-full sm:max-w-[min(90%,1500px)] px-4 sm:px-6",
        large && "sm:max-w-[min(95%,1600px)]",
        className,
      )}
    >
      {children}
    </div>
  );
}
